export interface IPrice {
    fromQty: number;
    unitPrice: number;
}
